import React from "react";

import "./WeChatScanner.scss";

class WeChatScanner extends React.Component {
  render() {
    return (
      <React.Fragment>
        <iframe
          className="embedded-site"
          id="inlineFrameExample"
          title="Inline Frame Example"
          src="https://s.laava.id/?cfg=sqr&n=0&f=0&l=0"
          allow="camera;microphone"
        ></iframe>
      </React.Fragment>
    );
  }
}

export default WeChatScanner;
